export const camelToKebabCase = (value: string) => {
  if (!value) {
    return '';
  }

  return value
    .split(/(?=[A-Z])/)
    .map((s) => s.toLowerCase())
    .join('-');
};
